import {
    ClipboardList,
    Wrench,
    Monitor,
    Globe2,
    Package,
    Settings,
    Link2,
    RefreshCw,
    CheckCircle2,
    Globe,
    FolderDown,
    BarChart3,
    Camera,
    FileText,
    Clock,
    RadioTower,
    Upload,
    ShieldAlert,
    Search,
    Star,
    MessageSquare
} from 'lucide-react';
import React from 'react';

export interface NavItem {
    id: string;
    label: string;
    icon: React.ElementType;
    color: string;
}

export interface NavGroup {
    group: string;
    items: NavItem[];
}

export const navSections: NavGroup[] = [
    {
        group: 'Getting Started',
        items: [
            { id: 'overview', label: 'Overview', icon: ClipboardList, color: 'text-blue-400' },
            { id: 'agent-types', label: 'Agent Types', icon: Wrench, color: 'text-orange-400' },
            { id: 'platforms', label: 'Supported Platforms', icon: Monitor, color: 'text-purple-400' },
        ],
    },
    {
        group: 'Master Gateway Agent',
        items: [
            { id: 'master-gateway', label: 'How It Works', icon: Globe2, color: 'text-cyan-400' },
            { id: 'master-prereqs', label: 'Prerequisites', icon: Package, color: 'text-amber-400' },
            { id: 'master-install', label: 'Installation Steps', icon: Settings, color: 'text-emerald-400' },
            { id: 'endpoint-install', label: 'Endpoint Agents', icon: Link2, color: 'text-indigo-400' },
            { id: 'comm-flow', label: 'Communication Flow', icon: RefreshCw, color: 'text-rose-400' },
        ],
    },
    {
        group: 'Lightweight Agent',
        items: [
            { id: 'lw-prereqs', label: 'Prerequisites', icon: CheckCircle2, color: 'text-green-400' },
            { id: 'lw-online', label: 'Online Installation', icon: Globe, color: 'text-sky-400' },
            { id: 'lw-offline', label: 'Offline Installation', icon: FolderDown, color: 'text-orange-400' },
            { id: 'asset-details', label: 'Asset Details', icon: BarChart3, color: 'text-violet-400' },
        ],
    },
    {
        group: 'Credentials Configuration',
        items: [
            { id: 'camera-creds', label: 'Camera Credentials', icon: Camera, color: 'text-red-400' },
            { id: 'camera-template', label: 'Camera Template', icon: FileText, color: 'text-yellow-400' },
            { id: 'camera-scheduler', label: 'Camera Scheduler', icon: Clock, color: 'text-teal-400' },
            { id: 'snmp-creds', label: 'SNMP Credentials', icon: RadioTower, color: 'text-orange-400' },
            { id: 'snmp-bulk', label: 'SNMP Bulk Upload', icon: Upload, color: 'text-blue-400' },
            { id: 'firewall-creds', label: 'Firewall Credentials', icon: ShieldAlert, color: 'text-rose-500' },
        ],
    },
    {
        group: 'Reference',
        items: [
            { id: 'troubleshooting', label: 'Troubleshooting', icon: Search, color: 'text-gray-400' },
            { id: 'best-practices', label: 'Best Practices', icon: Star, color: 'text-yellow-500' },
            { id: 'support', label: 'Support', icon: MessageSquare, color: 'text-pink-400' },
        ],
    },
];
